import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CatalogApp from './pages/Store';
import ProductDetailPage from './components/ProductDetailPage';
import Login from './pages/Login';
import Register from './pages/Register';
import AdminDashboard from './pages/AdminDashboard'; // Si ya lo creaste
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Ruta principal: Catálogo */}
        <Route path="/" element={<CatalogApp />} />
        <Route path="/product/:id" element={<ProductDetailPage />} />
        
        {/* Ruta de Login */}
        <Route path="/login" element={<Login />} />
        <Route path="/registrarse" element={<Register />} />

        {/* Ruta del Dashboard de Admin */}
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<h1>404 - Página no encontrada</h1>} />
      </Routes>
    </Router>
  );
}

export default App;